'use client';

import { useState, createContext } from 'react';
import { TAX_YEARS, CURRENT_TAX_YEAR } from '@/_constants/year-options';
import { setCookie, getCookie } from 'cookies-next/client';
import { SORABAN_YEAR_COOKIE } from '@/_constants/cookies';
import type { ClientDashboardProviderProps } from './ClientDashboardProvider.types';

const ClientDashboardContext = createContext<ClientDashboardProviderProps>({
  setYearFilter: () => null,
  yearFilter: TAX_YEARS[0].value,
  years: TAX_YEARS,
});

const ClientDashboardProvider = (props: any) => {
  const yearCookie: string = getCookie(SORABAN_YEAR_COOKIE) || CURRENT_TAX_YEAR;

  const [yearFilter, setYearFilter] = useState<string>(
    yearCookie || CURRENT_TAX_YEAR,
  );

  const onSetYearFilter = (newYear: string) => {
    setYearFilter(newYear);
    setCookie(SORABAN_YEAR_COOKIE, newYear);
  };

  return (
    <ClientDashboardContext
      value={{
        setYearFilter: onSetYearFilter,
        years: TAX_YEARS,
        yearFilter,
      }}
    >
      {props.children}
    </ClientDashboardContext>
  );
};

export { ClientDashboardContext, ClientDashboardProvider };
